import { isValid, parseISO } from 'date-fns';

type PacingGraphOverrides = {
    currentValue?: number;
    metricUpdatedAt?: string;
    statusId?: number;
};

const toFiniteNumber = (value: string | null) => {
    if (value === null || value.trim() === '') return undefined;

    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : undefined;
};

export const getPacingGraphOverrides = (
    params: URLSearchParams,
): PacingGraphOverrides => {
    const currentValue = toFiniteNumber(params.get('currentValue'));
    const metricUpdatedAt = params.get('metricUpdatedAt');
    const statusId = toFiniteNumber(params.get('statusId'));

    return {
        ...(currentValue !== undefined && currentValue >= 0
            ? { currentValue }
            : {}),
        ...(metricUpdatedAt && isValid(parseISO(metricUpdatedAt))
            ? { metricUpdatedAt }
            : {}),
        ...(statusId !== undefined && Number.isInteger(statusId) && statusId > 0
            ? { statusId }
            : {}),
    };
};
